module.exports = __webpack_public_path__ + "00558672.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HelpPage/block2img.jpeg
// module id = 2767
// module chunks = 15